/**
 * Un fichier du bureau entre dans la bibliothèque AVANT d'entrer dans un document : upload
 * direct Cloudinary (signé), puis le ContentMedium qui l'adosse — c'est lui que le calque
 * référence (`image.content_medium_id`, règle du dialecte, plan Composition §5). Jamais
 * d'url de session (`blob:`) dans un document : le serveur la refuse.
 *
 * Le média naît dans la médiathèque du LECTEUR (l'endpoint que l'éditeur reçoit, cf.
 * Toolbox::ContentMediaController#create) : visible, pour que son auteur le retrouve dans la
 * toolbox, jamais partagé — chez un dispenser, il n'inonde pas les bibliothèques des
 * affiliés (Toolbox::ContentMediaController).
 */
import { FetchRequest } from "@rails/request.js";
import { uploadSingleFile } from "../utils/cloudinary";

export interface LibraryMedium {
  id: number;
  url: string;
}

/** L'identifiant Cloudinary d'une url d'upload (`image/upload/v123/abc.jpg`). */
export function cloudinaryIdentifier(url: string): string | null {
  const match = url.match(/(?:image|video)\/upload\/[^?#]+/);
  return match ? match[0] : null;
}

export async function uploadToLibrary(file: File, endpoint: string): Promise<LibraryMedium> {
  const uploaded = await uploadSingleFile(file);
  const identifier = cloudinaryIdentifier(uploaded);
  if (!identifier) throw new Error(`Upload Cloudinary sans identifiant : ${uploaded}`);

  const request = new FetchRequest("post", endpoint, {
    body: JSON.stringify({ content_medium: { from_cloudinary_identifier: identifier } }),
    contentType: "application/json",
    responseKind: "json",
  });
  const response = await request.perform();
  if (!response.ok) throw new Error("La bibliothèque n'a pas accepté le fichier");

  const { content_medium: cm } = (await response.json) as { content_medium: LibraryMedium };
  return { id: cm.id, url: cm.url };
}
